import React from 'react';
import './ui.css';

type BadgeVariant = 'sport' | 'live' | 'market' | 'sportsbook' | 'neutral';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, variant = 'neutral', className = '' }) => {
  return <span className={`ui-badge ui-badge--${variant} ${className}`.trim()}>{children}</span>;
};

export default Badge;
